var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistImageCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6324_47058)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.414 11.5H21.4139C21.0161 11.4999 20.6347 11.3418 20.3534 11.0606C20.3534 11.0605 20.3534 11.0605 20.3534 11.0605L19.2324 9.93955L19.2324 9.9395C18.9512 9.6582 18.5698 9.50011 18.172 9.5L21.414 11.5ZM21.414 11.5H23C23.3978 11.5 23.7794 11.658 24.0607 11.9393C24.342 12.2206 24.5 12.6022 24.5 13V21C24.5 21.3978 24.342 21.7794 24.0607 22.0607C23.7794 22.342 23.3978 22.5 23 22.5H11C10.6022 22.5 10.2206 22.342 9.93934 22.0607C9.65804 21.7794 9.5 21.3978 9.5 21V13C9.5 12.6022 9.65804 12.2206 9.93934 11.9393C10.2206 11.658 10.6022 11.5 11 11.5H12.586H12.5861C12.9839 11.4999 13.3654 11.3418 13.6466 11.0605L14.7676 9.93955L14.7676 9.9395M21.414 11.5L14.7676 9.9395M14.7676 9.9395C15.0488 9.6582 15.4302 9.50011 15.828 9.5C15.828 9.5 15.8281 9.5 15.8281 9.5M14.7676 9.9395L15.8281 9.5M15.8281 9.5H18.1719H15.8281ZM17 20.5C17.4596 20.5 17.9148 20.4095 18.3394 20.2336C18.764 20.0577 19.1499 19.7999 19.4749 19.4749C19.7999 19.1499 20.0577 18.764 20.2336 18.3394C20.4095 17.9148 20.5 17.4596 20.5 17C20.5 16.5404 20.4095 16.0852 20.2336 15.6606C20.0577 15.236 19.7999 14.8501 19.4749 14.5251C19.1499 14.2001 18.764 13.9423 18.3394 13.7664C17.9148 13.5905 17.4596 13.5 17 13.5C16.0717 13.5 15.1815 13.8687 14.5251 14.5251C13.8687 15.1815 13.5 16.0717 13.5 17C13.5 17.9283 13.8687 18.8185 14.5251 19.4749C15.1815 20.1313 16.0717 20.5 17 20.5Z",
    fill: "#0061FF",
    stroke: "#0061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6324_47058",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6324_47058"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6324_47058",
    result: "effect2_dropShadow_6324_47058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6324_47058",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistImageCamera);
export default __webpack_public_path__ + "static/media/artistImage-camera.d12f0b354fb82eb681fc726cfc89a592.svg";
export { ForwardRef as ReactComponent };